import { CartProduct } from '~/src/common/typings/cart';
import { RecipeIngredientProductArticle } from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/types';

const isMissingQuantity = ({
  article,
  cartProducts,
}: {
  article: RecipeIngredientProductArticle;
  cartProducts: CartProduct[];
}) => {
  const cartQuantity = cartProducts.find(p => p.id === article.id)?.quotation2.count.quantity ?? 0;
  const remainingQuantity = article.availableQuantity - cartQuantity;

  return article.availableQuantity > 0 && article.quantity > remainingQuantity;
};

export default isMissingQuantity;
